var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"threeGlasses",staticClass:"three-glasses-animation"})
}
var staticRenderFns = []

export { render, staticRenderFns }